export default __webpack_public_path__ + "static/media/user_placeholder.811ae8d1.png";